import { Logger } from 'tslog';
export default class LoggerFactory {
    static createInstance(logLevel) {
        return new Logger({
            minLevel: logLevel,
        });
    }
}
